import { Typography } from '@mui/material';
import { useStyles } from './styles/LastUpdateText.styles';

export const LastUpdatedText = ({ lastUpdated }: { lastUpdated: string }) => {
    const classes = useStyles();

    return (
        <div className={classes.lastUpdatedTextWrapper}>
            <Typography className={classes.lastUpdatedText}>Last updated: {lastUpdated}</Typography>
        </div>
    );
};
